import { slugify } from "@/app/_utilities/slugify";

export const AGENT_TEMPLATE_PAGE_SIZE = 9;

export function getAgentTemplatePath(templateId: string, templateName?: string) {
  const slug = templateName ? slugify(templateName) : "";
  return `/agent-templates/template/${encodeURIComponent(templateId)}/${slug || "view"}`;
}

export function getAgentTemplatesListPath({
  currentPage,
  selectedCategorySlug,
}: {
  currentPage: number;
  selectedCategorySlug?: string;
}) {
  const basePath = selectedCategorySlug
    ? `/agent-templates/category/${encodeURIComponent(selectedCategorySlug)}`
    : "/agent-templates";

  return currentPage > 1 ? `${basePath}/page/${currentPage}` : basePath;
}

export function parseAgentTemplatesListPath(path?: null | string) {
  if (!path) {
    return {
      currentListUrl: "/agent-templates",
      currentPage: 1,
      selectedCategorySlug: undefined,
    };
  }

  const match = path.match(/^\/agent-templates(?:\/category\/([^/]+))?(?:\/page\/([^/?#]+))?\/?$/);

  if (!match) {
    return {
      currentListUrl: "/agent-templates",
      currentPage: 1,
      selectedCategorySlug: undefined,
    };
  }

  const selectedCategorySlug = match[1] ? decodeURIComponent(match[1]) : undefined;
  const currentPage = parseAgentTemplatePage(match[2] ?? "1");
  const currentListUrl = getAgentTemplatesListPath({
    currentPage,
    selectedCategorySlug,
  });

  return {
    currentListUrl,
    currentPage,
    selectedCategorySlug,
  };
}

export function parseAgentTemplatePage(page: string) {
  const parsedPage = Number(page);

  if (!Number.isInteger(parsedPage) || parsedPage < 1) {
    return 1;
  }

  return parsedPage;
}

export function clampAgentTemplatePage(page: number, totalPages: number) {
  if (page < 1) {
    return 1;
  }

  if (page > totalPages) {
    return totalPages;
  }

  return page;
}
